import styles from './advantages.module.scss';
import { observer } from 'mobx-react';
import Data from '../../data.json';
import { Images } from '../../components/images';
import classNames from 'classnames';
import { Children, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { AdvantagesCarousel } from './carousel';

const Advantages = observer(() => {
  const location = useLocation();

  const device: 'prime' | 'mid' | 'one' = location.pathname.split('/')[2] as
    | 'prime'
    | 'mid'
    | 'one';

  const deviceAdvantages = Data[device].advantages;

  return (
    <>
      <AdvantagesCarousel count={deviceAdvantages.length}>
        {deviceAdvantages.map((advantage, index) => (
          <div key={index} className={styles.advantages}>
            <div className={styles.textContent}>
              <h3 dangerouslySetInnerHTML={{ __html: advantage.text.title }} />
              <p
                dangerouslySetInnerHTML={{ __html: advantage.text.description }}
              />
            </div>

            <div className={styles.imgContent}>
              <img src={advantage.image} alt={advantage.text.title} />
            </div>
          </div>
        ))}
      </AdvantagesCarousel>
    </>
  );
});

export { Advantages };
